import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import useAgentCreateFormUtil from "./use-agent-create-form.util";
import FormFields from "./components/form-fields";
import FormButtons from "./components/form-buttons";

const AgentCreateForm = () => {
  const { validationSchema, submitForm, isLoading } = useAgentCreateFormUtil();
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });
  return (
    <div className="w-full">
      <form onSubmit={handleSubmit(submitForm)}>
        <FormFields control={control} errors={errors} />
        <div className="flex flex-grow items-center justify-end">
          <FormButtons isLoading={isLoading} />
        </div>
      </form>
    </div>
  );
};

export default AgentCreateForm;
